import Projects from './Projects'
import ProjectEdit from './ProjectEdit'

export const projectRoutes = [{
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true, minRole: 1}
  },
  {
    path: '/project/:id',
    name: 'ProjectEdit',
    component: ProjectEdit,
    meta: { requiresAuth: true, minRole: 2}
  }];


// WEBPACK FOOTER //
// ./src/CUSTOM/custom-modules/PROJECTS/routes.js